import React from "react";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import Problem from "@/sections/Problem";
import WhyDocumentCenter from "@/sections/WhyDocumentCenter";
import SmartSearch from "@/sections/SmartSearch";
import ConnectedDocuments from "@/sections/ConnectedDocuments";
import WorkspaceIntegration from "@/sections/WorkspaceIntegration";
import BusinessOutcomes from "@/sections/BusinessOutcomes";
import FAQ from "@/sections/FAQ";
import Footer from "@/sections/Footer";

export default function DocumentCenterLanding() {
  return (
    <div id="top" className="min-h-screen bg-[color:var(--dc-bg)] text-ink-950">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <WhyDocumentCenter />
        <SmartSearch />
        <ConnectedDocuments />
        <WorkspaceIntegration />
        <BusinessOutcomes />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
